import { render, staticRenderFns } from "./NotificationsActiveOutlined.vue?vue&type=template&id=f9c943ee&"
import script from "./NotificationsActiveOutlined.vue?vue&type=script&lang=js&"
export * from "./NotificationsActiveOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports